export default __webpack_public_path__ + "static/media/market1.e6da20cd.png";